import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-billing-actions-dropdown',
  templateUrl: './billing-actions-dropdown.component.html',
  styleUrls: ['./billing-actions-dropdown.component.css']
})
export class BillingActionsDropdownComponent implements OnInit {
  @Input() assign
  @Input() isView;
  @Output() adjustmentAction = new EventEmitter<any>();
  @Output() bankTripAction = new EventEmitter<any>();
  @Output() odometerAction = new EventEmitter<any>();
  @Output() signatureAction = new EventEmitter<any>();
  @Output() claimAction = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

}
